import { Checkbox, TableCell, TableRow } from '@mui/material'
import React from 'react'
import ToggleUser from '../toggle-user'
import { useDeleteUser } from '../../../../hooks/useDeleteUser'
import { useDispatch } from 'react-redux'
import { UserListSlice } from '../../../../reducers'
import { UserGroupPolicy } from '../../../../components/user-group-policy'
import { ALLOW_REMOVE_B2B_USER } from '../../../../util/permissions'
import { LoadingButton } from '@mui/lab'
import { DeleteForever } from '@mui/icons-material'

export default function UserTableRow ({
  user,
  hideStatusColumn,
  hideDeleteColumn,
  userPoolId,
  tenantId,
  handleSelect,
  isSelected,
  handleClick,
  isTempUser,
  disableCheckBox
}) {
  const dispatch = useDispatch()
  const { deleteUser, isDeleting } = useDeleteUser({
    onDeleteSuccess: (payload) => {
      dispatch(UserListSlice.actions.removeUserFromList(payload.username))
    }
  })

  const handleDeleteUser = (evt) => {
    evt.stopPropagation()

    if (!user || !tenantId) return

    deleteUser({
      username: user.username,
      tenantId
    })
  }

  const labelId = `users-table-checkbox-${user.username}`

  return (
    <TableRow key={user.username} hover onClick={() => handleClick(user)} sx={{ cursor: 'pointer' }}>
      <TableCell padding='checkbox'>
        <Checkbox
          color='primary'
          checked={isSelected}
          disabled={disableCheckBox}
          onClick={event => handleSelect(event, user)}
          inputProps={{
            'aria-labelledby': labelId
          }}
        />
      </TableCell>
      <TableCell>
        {user.givenName} {user.familyName}
      </TableCell>
      <TableCell>
        {user.email}
      </TableCell>
      {!hideStatusColumn && (
        <TableCell>
          <ToggleUser
            user={user}
            userPoolId={userPoolId}
          />
        </TableCell>
      )}
      {!hideDeleteColumn && (
        <TableCell>
          {!isTempUser && (
            <UserGroupPolicy
              accessGroup={ALLOW_REMOVE_B2B_USER}
              componentAllow={
                <LoadingButton
                  variant='outlined'
                  color='error'
                  startIcon={<DeleteForever />}
                  loading={isDeleting}
                  onClick={handleDeleteUser}
                  data-test='delete-user-btn'
                >
                  Delete
                </LoadingButton>
              }
            />
          )}
        </TableCell>
      )}
    </TableRow>
  )
}
